const texts = {
  title: 'به زیما خوش آمدید',
  form: {
    nationalCode: {
      label: 'شناسه ملی',
      placeholder: 'شناسه ملی شرکت خود را وارد کنید',
      helperText: 'شناسه ملی شامل ۱۱ رقم است',
    },
    button: 'ورود / ثبت‌نام',
  },
}

export default texts
